/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useState, useEffect, useRef } from "react";
import CheckBox from "../components/CheckBox";
import MultiSelect from "@khanacademy/react-multi-select";

const SearchMultiSelect = ({
  containerStyle,
  smallOptions = false,
  rightComponent,
  label,
  options = [],
  onChange,
  maxSelect,
  disabled = false,
  initialSelected,
  forceHasSelectAll,
  hasPreview = true,
  value: valProps,
  small,
  isLoading = false,
}) => {
  const isPreventOnChange = useRef(true);
  const [value, setValue] = useState([]);
  useEffect(() => {
    if (onChange && !isPreventOnChange.current) {
      onChange(value);
    }
    isPreventOnChange.current = false;
  }, [value]);
  useEffect(() => {
    setTimeout(() => {
      setValue((initialSelected || []).map((item) => item.value));
    }, 100);
  }, []);
  useEffect(() => {
    isPreventOnChange.current = true;
    setValue(valProps || []);
  }, [valProps]);
  return (
    <div
      id="select-dropdown"
      style={{ marginBottom: 15, ...(containerStyle || {}) }}
      className={smallOptions ? "small-options" : ""}
    >
      <div style={{ maxWidth: "100%", marginTop: 5 }} className={small ? "small-select" : ""}>
        {label ? (
          <label htmlFor="options" style={{ display: "inline-block", marginBottom: 5 }}>
            {label}
          </label>
        ) : null}
        <MultiSelect
          hasSelectAll={typeof forceHasSelectAll != "undefined" ? forceHasSelectAll : !maxSelect}
          styles={() => ({ valueContainer: { maxHeight: 100, backgroundColor: "red" } })}
          closeMenuOnSelect={false}
          overrideStrings={{ selectSomeItems: "Search" }}
          options={options}
          disabled={disabled}
          selected={value}
          isLoading={isLoading}
          onSelectedChanged={(value) => {
            if (!maxSelect || (forceHasSelectAll && value.length === options.length)) {
              setValue(value || []);
            } else if (maxSelect === 1) {
              setValue([value.pop()]);
            } else setValue((value || []).slice(0, maxSelect));
          }}
        />
      </div>
      {hasPreview ? (
        <div>
          {options.length >= 15 && options.length === value.length ? (
            <CheckBox item={{ label: "All Selected (" + options.length + ")" }} />
          ) : (
            options.map((item, i) => {
              if (value.indexOf(item.value) >= 0)
                return (
                  <CheckBox
                    item={item}
                    style={{ cursor: "default" }}
                    rightComponent={rightComponent}
                    key={`sms-${value}-${i}`}
                  />
                );
            })
          )}
        </div>
      ) : null}
    </div>
  );
};

export default SearchMultiSelect;
